import TypeProduit from '@/views/presse/parametrage/l_typeProduit';
import CouleurEncart from '@/views/presse/parametrage/l_couleurEncart';
import EmplacementPresse from '@/views/presse/parametrage/l_emplacementPresse';
import ListePeriodicite from '@/views/presse/parametrage/periodicite/l_periodicite';
import Surface from '@/views/presse/parametrage/l_surface';
import ModeDistribution from '@/views/presse/parametrage/l_modeDistribution';
import TypeFormatPresse from '@/views/presse/parametrage/typeFormatPresse/l_typeFormatPresse';
import AddEditTypeFormatPresse from '@/views/presse/parametrage/typeFormatPresse/m_typeFormatPresse';
import TypeEvenementSponsoring from '@/views/presse/parametrage/l_typeEvenementSponsoring';
import ListeParution from '@/views/presse/parution/l_parution';
import AddEditParution from '@/views/presse/parution/m_parution';
import DetailParution from '@/views/presse/parution/c_parution';
import TypeEvenement from '@/views/presse/parametrage/l_typeEvenement';
import EditBat from '@/views/presse/parution/m_bat';
import ListeMoisComptable from '@/views/compta/moisComptable/l_moisComptable';
import AddEditMoisComptable from '@/views/compta/moisComptable/m_moisComptable';
import DetailMoisComptable from '@/views/compta/moisComptable/c_moisComptable';
import EtatSuiviAdministratif from '@/views/presse/parametrage/l_etatSuiviAdministratif';
import CheminFerForParution from '@/views/presse/parution/m_cheminFer';

export default [
  {
    path: '/listeTypeProduit',
    component: TypeProduit,
    name: 'l.presse.type_produit',
  },
  {
    path: '/listeCouleurEncart',
    component: CouleurEncart,
    name: 'l.presse.couleur_encart',
  },
  {
    path: '/listePeriodicite',
    component: ListePeriodicite,
    name: 'l.presse.periodicite',
  },
  {
    path: '/listeEmplacementPresse',
    component: EmplacementPresse,
    name: 'l.presse.emplacement_presse',
  },
  {
    path: '/listeSurface',
    component: Surface,
    name: 'l.presse.surface',
  },
  {
    path: '/listeModeDistribution',
    component: ModeDistribution,
    name: 'l.presse.mode_distribution',
  },
  {
    path: '/listeTypeFormatPresse',
    component: TypeFormatPresse,
    name: 'l.presse.type_format_presse',
  },
  {
    path: '/addTypeFormatPresse',
    component: AddEditTypeFormatPresse,
    name: 'm.presse.type_format_presse-add',
  },
  {
    path: '/editTypeFormatPresse/:id',
    component: AddEditTypeFormatPresse,
    name: 'm.presse.type_format_presse-edit',
  },
  {
    path: '/listeTypeEvenementSponsoring',
    component: TypeEvenementSponsoring,
    name: 'l.presse.type_evenement_sponsoring',
  },
  {
    path: '/listeParution',
    component: ListeParution,
    name: 'l.presse.parution',
  },
  {
    path: '/listeParution/:produitId',
    component: ListeParution,
    name: 'l.presse.parution-listeByProduit',
  },
  {
    path: '/addParution/:produitId?',
    component: AddEditParution,
    name: 'm.presse.parution-add',
  },
  {
    path: '/editParution/:id',
    component: AddEditParution,
    name: 'm.presse.parution-edit',
  },
  {
    path: '/detailParution/:id',
    component: DetailParution,
    name: 'c.presse.parution',
  },
  {
    path: '/listeTypeEvenement',
    component: TypeEvenement,
    name: 'l.presse.type_evenement_pm',
  },
  {
    path: '/suiviBat/:parutionId',
    component: EditBat,
    name: 'm.presse.parution-bat',
  },
  {
    path: '/cheminFer/:parutionId',
    component: CheminFerForParution,
    name: 'm.presse.chemin_fer',
  },
  {
    path: '/listeMoisComptable',
    component: ListeMoisComptable,
    name: 'l.presse.mois_comptable',
  },
  {
    path: '/addMoisComptable',
    component: AddEditMoisComptable,
    name: 'm.presse.mois_comptable-add',
  },
  {
    path: '/editMoisComptable/:id',
    component: AddEditMoisComptable,
    name: 'm.presse.mois_comptable-edit',
  },
  {
    path: '/detailMoisComptable/:id',
    component: DetailMoisComptable,
    name: 'c.presse.mois_comptable',
  },
  {
    path: '/listeEtatSuiviAdministratif',
    component: EtatSuiviAdministratif,
    name: 'l.presse.etat_suivi_administratif',
  },
];
